import React from 'react'
import clsx from 'clsx'
import styles from './styles.module.scss'

type RectangularButtonProps = (
    | ({
          type: 'a'
      } & React.AnchorHTMLAttributes<HTMLAnchorElement>)
    | ({
          type?: 'button'
      } & React.ButtonHTMLAttributes<HTMLButtonElement>)
) & {
    color?: 'primary' | 'lightgrey'
    flatIcon?: string
}

export const RectangularButton = ({
    type,
    color = 'primary',
    flatIcon,
    children,
    className,
    ...props
}: RectangularButtonProps) => {
    const Component = type === 'a' ? 'a' : 'button'
    return (
        <Component className={clsx(styles.button, styles[color], className)} {...(props as any)}>
            {flatIcon ? <i className={clsx(`fi fi-rs-${flatIcon}`, styles.icon)} /> : null}
            {children}
        </Component>
    )
}
